import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';


const fetchCommonAreasDone = ( _, { payload }) => {
    return [
      ...payload
    ]

    // return {
    //   areas: [ ...payload ]
    // }
  }
// const fetchPropertyCommonAreasDone = (commonAreas,{ payload }) => {
//   // let propertyCommonAreas = [ ...payload ];
  
//   commonAreas.propertyCommonAreas = payload;
  
//   // commonAreas.propertyCommonAreas = [ ...payload.propertyCommonAreas ];
//   // commonAreas.loading = payload.loading
  
//   return commonAreas
  
//   //  {
//   //   commonAreas,
//   //   propertyCommonAreas
//   // }
// }

const initialState = [];

export default createReducer(initialState, {
  [TYPES.FETCH_COMMON_AREAS_DONE] : fetchCommonAreasDone,
  // [TYPES.FETCH_PROPERTY_COMMON_AREAS_DONE]:fetchPropertyCommonAreasDone
});